import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import { Grid, Radio, Button, withStyles, Typography } from '@material-ui/core'
import { MultipleDayPicker } from '../../../../../common/components/UI/Datepicker/MultipleDayPicker'
import { updateMobileOfferForm } from '../../../actions/mobileActions'
import { resetProposablePrivateEmployee } from '../../../actions'
import { EmployeeDashboardMobileSidePanelStyles } from '../../../../styles/mobileStyles'
import { TorCreationType } from '../../../../Enums';
class SendTo extends Component {
    generateMultipleDayPicker = () => {
        const { formData, classes, updateMobileOfferForm } = this.props

        if (!formData.managerSetting || formData.managerSetting.type !== 1 || !formData.managerSetting.isShiftSwapEmployeePreferencesEnabled) {
            return
        }
        return (
            <React.Fragment>
                <Typography variant={'h5'} className={classes.viewHeader}>Preferred swap dates: </Typography>
                <MultipleDayPicker
                    callback={(selected) => { updateMobileOfferForm({ preferredDates: selected }) }}
                    selectedDays={formData.preferredDates}
                    isReadOnly={false}
                    containerStyle={classes.preferredDayPickerContainer}
                >
                </MultipleDayPicker>
            </React.Fragment>
        )
    }

    render() {
        const { formData, updateMobileOfferForm, resetProposablePrivateEmployee, classes, updateSidePanelView, handlePreviousView } = this.props
        const nextPage = formData.isPrivate ? 'PrivateOffer' : formData.managerSetting.timeOffRequestCreationType === TorCreationType.Optional || formData.managerSetting.timeOffRequestCreationType === TorCreationType.Required ? 'TimeOffRequestCreation' : 'Summary';
        return (
            <Fragment>
                <div className={classes.viewContainer}>
                    <Typography variant={'h5'} className={classes.viewHeader}>Send to: </Typography>
                    <Button fullWidth onClick={(e) => { updateMobileOfferForm({ ...formData, isPrivate: false, privateEmployeeSelected: [] }); resetProposablePrivateEmployee() }} className={classes.formButtonWithHover}>
                        <Radio
                            color="primary"
                            checked={!formData.isPrivate}
                            value="false"
                        />
                        To billboard
                    </Button>
                    <Button fullWidth onClick={(e) => { updateMobileOfferForm({ ...formData, isPrivate: true }) }} className={classes.formButtonWithHover}>
                        <Radio
                            color="primary"
                            checked={formData.isPrivate}
                            value="true"
                        />
                        To employee(s)
                    </Button>
                    {this.generateMultipleDayPicker()}
                    <Grid container className={classes.bottomBar}>
                        <Grid item xs={6} style={{ padding: '5px' }}>
                            <Button fullWidth className={classes.secondaryButton} onClick={handlePreviousView}>
                                Back
                            </Button>
                        </Grid>
                        <Grid item xs={6} style={{ padding: '5px' }}>
                            <Button fullWidth className={classes.primaryButton} onClick={() => updateSidePanelView(nextPage)}>
                                Next
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        formData: state.mobileOfferShiftForm
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
        resetProposablePrivateEmployee: payload => dispatch(resetProposablePrivateEmployee(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(EmployeeDashboardMobileSidePanelStyles)(SendTo));